import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import WebUI1440Articles from 'components/Web_User_Interface/1440p_Series/Alarm/IntroWebUIAlarm1440';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Alarm Menü",
  "path": "/Web_User_Interface/1440p_Serie/Alarm/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR Web User Interface - Alarm Menü",
  "image": "./WebUI_1440p_SearchThumb_Alarm.webp",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Alarm.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Alarm Menu :: INSTAR 2k+ (WQHD) Web User Interface' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='IP-Kamera Bewegungserkennungseinstellungen' image='/images/Search/WebUI_1440p_SearchThumb_Alarm.webp' twitter='/images/Search/WebUI_1440p_SearchThumb_Alarm.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Alarm/' locationFR='/fr/Web_User_Interface/1440p_Series/Alarm/' crumbLabel="Alarm Menu" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "alarm-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarm-men%C3%BC",
        "aria-label": "alarm menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Menü`}</h2>
    <WebUI1440Articles mdxType="WebUI1440Articles" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      